import classNames from 'classnames';
import styles from './styles/styles.module.scss';

type CardLinkProps = {
  ariaLabel?: string;
  children?: React.ReactNode;
  href: string;
  openInNewTab?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  isOverlay?: boolean;
  overlayFocusStyle?: 'offset' | 'border';
  preventFocus?: boolean;
  className?: string;
  blockNavigation?: boolean;
  testId?: string;
};

const CardLink = ({
  ariaLabel,
  children,
  href,
  openInNewTab = false,
  onClick,
  isOverlay,
  overlayFocusStyle,
  preventFocus,
  className,
  blockNavigation,
  testId
}: CardLinkProps) => {
  const linkProps: React.HTMLProps<HTMLAnchorElement> = {
    'aria-label': ariaLabel,
    tabIndex: preventFocus ? -1 : 0,
    className: classNames(
      preventFocus && styles.hideFocus,
      className,
      isOverlay && styles.overlay,
      overlayFocusStyle === 'offset' ? styles.focusOffset : styles.focusBorder
    ),
    href,
    onClick: onClick
      ? e => {
          if (blockNavigation) {
            e.preventDefault();
            e.stopPropagation();
          }
          onClick(e);
        }
      : undefined
  };

  return openInNewTab ? (
    <a {...linkProps} target="_blank" rel="noopener noreferrer" data-testid={testId}>
      {children}
    </a>
  ) : (
    <a {...linkProps} data-testid={testId}>
      {children}
    </a>
  );
};

export default CardLink;
